
// Export empty array for now since we removed the specific handlers
export const handlers: Array<(content: string, config: any) => string | null> = [];
